import * as yup from 'yup';

export const validationSchema = yup.object({
    inn: yup
        .string()
        .required('Заполните поле')
        .min(10, 'Поле должно содержать не менее 10 символов')
        .max(12, 'Должно быть не более 12 символов.'),
    name: yup
        .string()
        .required('Заполните поле')
        .min(2, 'Поле должно содержать не менее 2 символов')
        .max(40, 'Должно быть не более 40 символов.'),
    contact: yup
        .string()
        .required('Заполните поле')
        .test(
            'phone-or-email',
            'Неверный формат',
            (value: string | any): boolean => {
                const regexMail =
                    /^([\w-]+(?:\.[\w-]+)*)@((?:[\w-]+\.)*\w[\w-]{0,66})\.([a-z]{2,6}(?:\.[a-z]{2})?)$/i;
                const regexPhone =
                    /^(\+7|7|8)?[\s-]?\(?[489][0-9]{2}\)?[\s-]?[0-9]{3}[\s-]?[0-9]{2}[\s-]?[0-9]{2}$/;
                return regexMail.test(value) || regexPhone.test(value);
            }
        ),
    message: yup
        .string()
        .max(500, 'Должно быть не более 500 символов.')
        .required('Заполните поле'),
    checkbox: yup
        .boolean()
        .oneOf([true], 'Необходимо согласие на обработку персональных данных'),
});
